import RedemptionsList from "./RedemptionsList";
export default RedemptionsList;
